import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledHeaderButton } from '../Header/styles';
import { StyleColor } from '../../../utils/styles-constants';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { toggleEditPanel } from '../../../containers/Editor/actions';
import { IGNORE_PAGE_CLICK_CLASS } from '../Page';
import { PAGE_BACKGROUND_CLICK_CLASS } from '../Page/Background';

interface ButtonEditProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonEdit = ({ isDisabled, dispatch }: ButtonEditProps) => (
	<StyledHeaderButton
		className={`${IGNORE_PAGE_CLICK_CLASS} ${PAGE_BACKGROUND_CLICK_CLASS}`}
		width="23px"
		height="23px"
		disabled={isDisabled}
		color={isDisabled ? StyleColor.White : StyleColor.Blue600}
		onClick={() => dispatch(toggleEditPanel())}
	>
		{isDisabled
			? Utils.getSvgIcon('iconset_uprez_brush')
			: Utils.getSvgIcon('iconset_uprez_brush-bold')
		}
	</StyledHeaderButton>
);

export default ButtonEdit;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonEdit/index.tsx